import { render, staticRenderFns } from "./BpcTableActivities.vue?vue&type=template&id=61ab98e2&"
import script from "./BpcTableActivities.vue?vue&type=script&lang=js&"
export * from "./BpcTableActivities.vue?vue&type=script&lang=js&"
import style0 from "./BpcTableActivities.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports